import isSelfService from '@/common/utils/isSelfService';
import useAuthStore from '@/common/store/pinia/auth';

export const isNotificationForCurrentProject = (eventProjectId: string | undefined): boolean => {
  if (isSelfService()) return true;
  if (!eventProjectId) return true;
  return eventProjectId === useAuthStore().currentUserProjectId;
};

export default isNotificationForCurrentProject;
